import DocumentImagePdf from 'assets/illustrations/document-enabled.svg';
import DocumentImage from 'assets/illustrations/photo-ilustration.svg';
import {
  EDocumentExtensions,
  EImageExtensions,
} from 'modules/accommodations/features/rentals/CreateRental/Contracts/components/consts';

export const getImageByExtension = (extension: string | undefined | null) => {
  switch (extension) {
    case EImageExtensions.png:
      return DocumentImage;

    case EImageExtensions.jpg:
      return DocumentImage;

    case EDocumentExtensions.pdf:
      return DocumentImagePdf;

    default:
      return DocumentImage;
  }
};
